// extracted by extract-css-chunks-webpack-plugin
module.exports = {"reviewsContainer":"reviewsContainer___WH5aW","header":"header___ocBNg","controls":"controls___2HDho","seeAll":"seeAll___1VdKe"};